/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Detail of a modification within an event group (displayed on hover/expansion)
 * @export
 * @interface HistoryModificationDetailDto
 */
export interface HistoryModificationDetailDto {
    /**
     * Unique identifier of the detail event
     * @type {string}
     * @memberof HistoryModificationDetailDto
     */
    id: string;
    /**
     * Title of the modification
     * @type {string}
     * @memberof HistoryModificationDetailDto
     */
    title: string;
    /**
     * Detailed message of the modification
     * @type {string}
     * @memberof HistoryModificationDetailDto
     */
    message: string;
    /**
     * Timestamp when the modification occurred
     * @type {Date}
     * @memberof HistoryModificationDetailDto
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the HistoryModificationDetailDto interface.
 */
export function instanceOfHistoryModificationDetailDto(value: object): value is HistoryModificationDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function HistoryModificationDetailDtoFromJSON(json: any): HistoryModificationDetailDto {
    return HistoryModificationDetailDtoFromJSONTyped(json, false);
}

export function HistoryModificationDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryModificationDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function HistoryModificationDetailDtoToJSON(json: any): HistoryModificationDetailDto {
    return HistoryModificationDetailDtoToJSONTyped(json, false);
}

export function HistoryModificationDetailDtoToJSONTyped(value?: HistoryModificationDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

